/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Preview_TitleInputs */

const cs_pm_preview_title = /** @type {(inputs: Pm_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`náhled párování`)
};

const en_pm_preview_title = /** @type {(inputs: Pm_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`matching preview`)
};

/**
* | output |
* | --- |
* | "matching preview" |
*
* @param {Pm_Preview_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_preview_title = /** @type {((inputs?: Pm_Preview_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Preview_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_preview_title(inputs)
	return cs_pm_preview_title(inputs)
});